import React, { useState } from "react";
import GenericUI from '../generic.ui';
import {Translator} from "../../translator";

//import "./styles/smartphone.css";
//import "./styles/tablet.css";
import "./styles/desktop.css";

export default class AccessoriesPanel extends GenericUI
{
    constructor( props ) {
        super( props );
    }

    componentDidMount()
    {
        window.AccessoriesPanel = this;
    }

    render()
    {
        super.render();
        return (
            <div id="accPanel" className="accessories-panel">

                <AccessoryItem tool="youtube" url="https://www.youtube.com/channel/UCqqP2tA_D4fPVWQBi6DrXkg" />
                <AccessoryItem tool="discord" url="https://discord.gg/N3edAGkSXh" />
                <AccessoryItem tool="facebook" url="https://www.facebook.com/groups/aozstudio" />


                <AccessoryItem tool="ascii-viewer" url="./accessories/ascii_viewer/html/index.html" />
                <AccessoryItem tool="fontviewer" url="./accessories/fontviewer/html/index.html" />
                <AccessoryItem tool="joytester" url="./accessories/joystick_tester/html/index.html" />
                <AccessoryItem tool="keytester" url="./accessories/keyboard_tester/html/index.html" />
                <AccessoryItem tool="uidemo" url="https://uidemo.aozwithphil.com/index2.html" />


                <AccessoryItem tool="3d-editor" url="./accessories/3d-editor/index.html" />
                <AccessoryItem tool="modtracker" url="https://www.stef.be/bassoontracker/" />
                <AccessoryItem tool="sfxjs" url="https://sfxr.me/" />  

                <AccessoryItem tool="opengameart" url="https://opengameart.org/" />
                <AccessoryItem tool="kenney" url="https://kenney.nl/" />
                <AccessoryItem tool="craftpix" url="https://craftpix.net/" />

                <AccessoryItem tool="free_music" url="https://freesfx.co.uk/Music.aspx" />
                <AccessoryItem tool="modarchive" url="https://modarchive.org/index.php" />
                <AccessoryItem tool="freesfx" url="https://freesfx.co.uk/Default.aspx" />
              

            </div>
        );
    }
}

function AccessoryItem( props ) {
    return (
        <div 
            className="accessory-item" 
            alt={Translator.get(props.tool)} 
            title={Translator.get(props.tool)}
            style={{ backgroundImage: `url(./accicons/${props.tool}.png)` }} 
            onClick={ (e) => { openAccessory(props.url, props.tool) } }
        ></div>
    );
}

function AccessorySeparator( props ) {
    return (
        <div 
            className="accessory-separator" 
        >
            {Translator.get(props.text)}
        </div>
    );
}

function openAccessory( url, winName )
{
    window.open( url, winName, 'width=1280,height=800,popup=yes' );
}